import { Card } from "@shared/ui/card";
import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { Badge } from "@shared/ui/badge";
import { Route } from "lucide-react";

export const DetailsHeader = ({ routeDetails }) => {
  const route = routeDetails?.[0];
  const details = [
    { label: "Route Name", value: route?.routeName || "NA" },
    { label: "Route ID", value: route?.id || "NA" },
    {
      label: "Utility Service's",
      value: route?.utilityService?.join(", ") || "NA",
    },
    { label: "Meter Type", value: route?.meterTypeDisplay || "NA" },
    {
      label: "Consumer Category",
      value: route?.categoryName?.join(", ") || "NA",
    },
    {
      label: "Consumer Subcategory",
      value: route?.subcategoryName?.join(", ") || "NA",
    },
  ];

  const readCycleDetails = [
    { label: "Read Cycle Name", value: route?.readCycleName || "NA" },
    { label: "Read Cycle ID", value: route?.readCycleId || "NA" },
    { label: "Area", value: route?.areaName?.join(", ") || "NA" },
    { label: "Subarea", value: route?.subAreaName?.join(", ") || "NA" },
    { label: "Next Reading Period", value: route?.nextRunDate || "NA" },
  ];

  const auditDetails = [
    { label: "Created By", value: route?.createdUserRemoteName || "NA" },
    { label: "Created On", value: route?.createdDate || "NA" },
    { label: "Last Updated On", value: route?.lastModifiedDate || "NA" },
  ];
  const activeStatus = route?.isActive ? "Active" : "Inactive";

  return (
    <Card className="p-4 shadow-sm">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Route className="w-5 h-5 text-blue-600" />
          <h2 className="text-lg font-semibold">{route?.routeName}</h2>
        </div>
        <Badge className="bg-green-100 text-green-700 border border-green-300 rounded-xl px-2 py-1">
          {activeStatus}
        </Badge>
      </div>

      {/* Value grid */}
      <Card>
        <div>
          <h3 className="text-sm font-semibold text-foreground">
            Route Overview
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-4 mt-3">
          {details.map((item) => (
            <ValueLabel
              key={item.label}
              label={item.label}
              value={item.value}
            />
          ))}
        </div>
      </Card>
      <Card className="mt-2">
      <div>
        <h3 className="text-sm font-semibold text-foreground">
          Read Cycle & Coverage
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-4 mt-3">
        {readCycleDetails.map((item) => (
          <ValueLabel key={item.label} label={item.label} value={item.value} />
        ))}
      </div>
      </Card>
      <Card className="mt-2">
      <div>
        <h3 className="text-sm font-semibold text-foreground">
          Administrative & Audit Information
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-4 mt-3">
        {auditDetails.map((item) => (
          <ValueLabel key={item.label} label={item.label} value={item.value} />
        ))}
      </div>
      </Card>
    </Card>
  );
};